'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'knife-kitchen';
var width = 576;
var height = 512;
var aliases = [128298];
var unicode = 'f6f5';
var svgPathData = 'M480.6 6.9l88 80 6 5.4-5.5 5.9L464 211.1l0 60.9 0 5.3-4.8 2.1-56 24-5 2.1-3.8-3.8-104-104-5.7-5.7 5.7-5.7L469.5 7.1l5.4-5.4 5.6 5.1zM307.3 192l94.5 94.5L448 266.7l0-58.7 0-3.1 2.1-2.3L551.8 93.3 475.5 23.9 307.3 192zM11.3 468.5L243.2 231.1l11.3 11.3L25.3 477c2.7 1.4 5.8 2.8 9.2 4.3c17 7.2 42.9 14.7 77.4 14.7c111.3 0 182.7-47.6 255.4-118.2l-20.6-20.6-11.3-11.3 11.3-11.3 43.3 43.3c-3.8 3.8-7.6 7.5-11.4 11.2C304.6 461.2 229.3 512 112 512c-48.2 0-81.2-13.6-98.3-23.1C4.6 483.9 0 480 0 480l11.3-11.5zM416 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faKnifeKitchen = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;